import type { InfiniteData } from '@tanstack/react-query';

import type { VehicleListFetcher } from '../useFetchVehicleList/useFetchVehicleList.types';

const DEFAULT_NEXT_PAGE = 1;
const DEFAULT_FALLBACK_PAGE = 0;

export const getCurrentPage = (vehicles?: InfiniteData<VehicleListFetcher>): number => {
	if (!vehicles || !vehicles.pages || vehicles.pages.length === 0) {
		return DEFAULT_FALLBACK_PAGE;
	}

	const lastPage = [...vehicles.pages].pop();
	const lastPageNextPage = lastPage?.nextPage || DEFAULT_NEXT_PAGE;
	/*
	 * Last `nextPage` is actual next page value therefore we need to
	 * subtract 1 from it which will give us current page
	 */
	return lastPageNextPage > 0 ? lastPageNextPage - 1 : DEFAULT_FALLBACK_PAGE;
};
